import $ from 'jquery';
import { makeText, setHtml } from './lib.js';

export function show() {
  const emptyContentCssPath = '.empty-content';
  $(emptyContentCssPath).show();
}

export function setText(text) {
  const element = makeText('.empty-content__subtext');
  setHtml(text, element);
}

export function hide() {
  const element = document.querySelector('.empty-content');
  if (element) {
    element.style.display = 'none';
  }
}
